'use client';

import React, { useState } from 'react';
import { Chatbot, ChatbotProps } from '../../Chatbot';
import { ChatHeader } from '../ChatHeader';
import vetAssistantImg from '../../assets/vet-assistant.png';
import vetAssistantNotificationImage from '../../assets/vet-assistant-notification@2x.png';
import vetGroupImg from '../../assets/vet-group.png';
import closeIcon from '../../assets/close-icon@2x.png';
import { TooltipBouncer, TooltipBouncerProps } from '../../../floating-action-buttons';
import { theme } from '../../../../themes/base-theme';
export type VetChatbotProps = {
  steps: ChatbotProps['steps'];
  chatbotProps?: Omit<ChatbotProps, 'steps'>;
  toggleFloating?: ChatbotProps['toggleFloating'];
  tooltipText?: string;
  isOpen: boolean;
};
export const VetChatbot = ({
  steps,
  isOpen,
  chatbotProps,
  toggleFloating,
  tooltipText
}: VetChatbotProps) => {
  const [isChatOpen, setChatOpen] = useState(isOpen);
  const [showNotification, setNotificationVisiblity] = useState(true);
  const handleVetChatOpened = () => {
    setChatOpen(!isChatOpen);
    setNotificationVisiblity(false);
  };
  const {
    avatarStyle,
    bubbleStyle,
    contentStyle,
    inputStyle,
    style,
    ...restChatbotProps
  } = chatbotProps || {};
  const defaultTooltipBouncerProps: Partial<TooltipBouncerProps> = {
    right: 0,
    width: 'fit-content'
  };
  return <Chatbot chatButtonImage={vetAssistantImg} steps={steps} isOpen={isChatOpen} enableMobileAutoFocus cache cacheName="vet-chat" avatarStyle={{
    boxShadow: 'none',
    ...avatarStyle
  }} botAvatar={vetAssistantImg} toggleFloating={() => {
    if (toggleFloating) {
      toggleFloating();
    }
    handleVetChatOpened();
  }} bubbleStyle={{
    borderRadius: '8px',
    ...bubbleStyle
  }} contentStyle={{
    bg: 'white',
    maxHeight: '300px',
    minHeight: '250px',
    overflowY: 'scroll',
    ...contentStyle
  }} headerComponent={<ChatHeader chatHeaderText="2,708 satisfied customers" chatHeaderImage={vetGroupImg} />} hideUserAvatar inputStyle={{
    fontFamily: 'muli',
    boxShadow: '0 -3px 7px 0 rgba(16,41,65,0.09)',
    minHeight: '20px',
    ...inputStyle
  }} floatingIcon={isChatOpen ? <TooltipBouncer {...defaultTooltipBouncerProps} avatar={{
    src: closeIcon,
    alt: 'close-icon',
    width: '64px',
    height: '64px',
    containerProps: {
      border: 'none'
    }
  }} tooltip={{
    text: '',
    show: false
  }} /> : <TooltipBouncer {...defaultTooltipBouncerProps} avatar={{
    src: showNotification ? vetAssistantNotificationImage : vetAssistantImg,
    alt: 'Mobile Bouncer Alt',
    width: '72px',
    height: '72px',
    borderRadius: '0%',
    containerProps: {
      borderColor: 'white',
      borderRadius: '0%'
    },
    imageProps: {
      borderRadius: '0%'
    }
  }} tooltip={{
    text: tooltipText || 'Need vet advice?',
    backgroundColor: theme.colors.gulfBlue,
    width: '200px',
    height: '63px',
    display: 'flex',
    fontSize: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    placement: 'left',
    right: '110%',
    top: '5%',
    marginBottom: '4px',
    marginLeft: '-9px',
    borderWidth: '8px',
    // TooltipText doesn't have theme provided
    tooltipColor: theme.colors.gulfBlue
  }} />} placeholder="Tell us about your pet..." style={{
    marginRight: '10px',
    marginLeft: '10px',
    marginBottom: '100px',
    marginTop: '10px',
    maxWidth: '90%',
    minHeight: '300px',
    borderRadius: '8px',
    boxShadow: '0 0 9px 0 rgba(0,0,0,0.16)',
    ...style
  }} userDelay={100} {...restChatbotProps} data-sentry-element="Chatbot" data-sentry-component="VetChatbot" data-sentry-source-file="VetChatbot.tsx" />;
};